module.exports = __webpack_public_path__ + "static/media/PCBA-01.047d226d.jpeg";